import { render } from "./MyArchivedVouchersPage.vue?vue&type=template&id=e29549ec"
import script from "./MyArchivedVouchersPage.vue?vue&type=script&lang=js"
export * from "./MyArchivedVouchersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__